import {
  ArrowLineDown,
  CurrencyBtc,
  Briefcase,
  Coins,
  Gift,
  House,
  Sparkle,
  TrendUp,
  Wallet,
} from '@phosphor-icons/react';

/** Nomes Lucide por categoria — alinhado com `apps/income/suggestions.py`. */
export const INCOME_CATEGORY_ICON_NAMES = {
  salary: 'Wallet',
  freelance: 'Briefcase',
  capital_gains: 'TrendUp',
  rental: 'House',
  crypto: 'CurrencyBtc',
  extraordinary: 'Gift',
  secondary: 'Sparkle',
  transfers: 'ArrowLineDown',
  other: 'Coins',
};

const LUCIDE_BY_NAME = {
  Wallet,
  Briefcase,
  TrendUp,
  House,
  CurrencyBtc,
  Gift,
  Sparkle,
  ArrowLineDown,
  Coins,
};

export function defaultIconNameForCategory(category) {
  return INCOME_CATEGORY_ICON_NAMES[category] || INCOME_CATEGORY_ICON_NAMES.other;
}

export function resolveIncomeSourceIcon(source) {
  const explicit = source?.icon?.trim();
  if (explicit && LUCIDE_BY_NAME[explicit]) {
    return LUCIDE_BY_NAME[explicit];
  }
  const category = source?.category || 'other';
  const fallbackName = defaultIconNameForCategory(category);
  return LUCIDE_BY_NAME[fallbackName] || Coins;
}

export function resolveIncomeSourceColor(source) {
  return source?.color || '#7C9E6F';
}
